// getters.js

export default {
    getSystemList(state){
        return state.systemList
    },
    getCurrentSystem(state){
        return state.currentSystem
    },
    getCurrentSystemData(state){
        if(state.currentSystem.value){
            return state.systemList.find(item=>item.id === state.currentSystem.value)
        } else {
            return null
        }
    },
    getIsShowHeaderSystemFilter(state){
        return state.showHeaderSystemFilter
    }
};
